import React, { useState } from "react";
function Button(props) {
  const [size] = useState(props.size);
  const [type] = useState(props.type);
  const [Color] = useState(props.color);
  const [variant] = useState(props.variant);
  return (
    <button className={`btn ${variant} ${size} ${Color}`} type={type}>{props.children}</button>
  );
}
export default Button;